import { Box } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { IndexadorForm } from "core/features/indexador/typings";
import colors from "core/resources/theme/colors";
import React from "react";
import { Control } from "react-hook-form";
import { BiEdit } from "react-icons/bi";
import Field from "../Field";

interface FormIndexadorHeaderProps {
  control: Control<IndexadorForm, object>;
  enabledEdit: boolean;
  onExcelInput: () => any;
  onEnableEdit: () => any;
  loading?: boolean;
}
function FormIndexadorHeader({
  control,
  enabledEdit,
  onExcelInput,
  onEnableEdit,
  loading,
}: FormIndexadorHeaderProps) {
  return loading ? (
    <Text>Carregando...</Text>
  ) : (
    <>
      <Field
        control={control}
        name="nome"
        rules={{ required: true }}
        inputProps={{
          disabled: !enabledEdit,
          placeholder: "Nome do peso",
          fontWeight: "bold",
          fontSize: 18,
          width: "220px",
          textDecoration: "underline",
          borderColor: "#00000000",
          _disabled: {
            background: "none !important",
            pointerEvents: "none",
          },
        }}
      />

      <Box mx={4} mt="7px">
        <BiEdit
          color={colors.primary}
          size={24}
          onClick={onEnableEdit}
          cursor="pointer"
          aria-label="Editar peso"
          aria-roledescription="Botão de editar peso"
          style={{ marginTop: "auto", marginBottom: "auto" }}
        />
      </Box>

      {/* <InputExcel onReadExcelFile={console.log} /> */}
    </>
  );
}

export default FormIndexadorHeader;
